import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import InnerBanner from "../InnerBanner";

const INITIAL_BANNER = {
  image: null,
  MobileBanner: null,
  title: "",
  subtitle: "",
  skew: false,
  bannershow: false,
  titleClass: "",
};

const LayoutInnerPage = () => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = React.useState("");
  const [pageSubtitle, setPageSubtitle] = React.useState("");
  const [showExtra, setShowExtra] = React.useState(false);
  const [bannerData, setBannerData] = React.useState(INITIAL_BANNER);
  const [bannerPath, setBannerPath] = React.useState(location.pathname);

  // Layout stays mounted across inner routes, so reset leftover banner
  // state during render when the path changes (before paint).
  if (bannerPath !== location.pathname) {
    setBannerPath(location.pathname);
    setBannerData(INITIAL_BANNER);
  }
  return (
    <>
      <Header title={pageTitle} subtitle={pageSubtitle} />
      {/* <div className="mx-auto max-w-[1536px] p-4 pb-20 md:p-6 md:pb-6"> */}
      <div className="flex-1">
        <InnerBanner
          showExtra={showExtra}
          titleClass={bannerData.titleClass}
          image={bannerData.image}
          MobileBanner={bannerData.MobileBanner}
          title={bannerData.title}
          subtitle={bannerData.subtitle}
          skew={bannerData.skew}
          bannershow={bannerData.bannershow}
        />
        <section className="px-6 md:px-8 lg:px-14 md:my-10 overflow-hidden innerSection [&_.splide\_\_track]:!overflow-visible">
          <Outlet context={{ setPageTitle, setPageSubtitle, setBannerData }} />
        </section>
      </div>
      <Footer/>
    </>
  );
};

export default LayoutInnerPage;
